/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M15 7L9 17M10 9.5C10 10.3284 9.32843 11 8.5 11C7.67157 11 7 10.3284 7 9.5C7 8.67157 7.67157 8 8.5 8C9.32843 8 10 8.67157 10 9.5ZM17 14.5C17 15.3284 16.3284 16 15.5 16C14.6716 16 14 15.3284 14 14.5C14 13.6716 14.6716 13 15.5 13C16.3284 13 17 13.6716 17 14.5Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM10 9.5C10 10.3284 9.32843 11 8.5 11C7.67157 11 7 10.3284 7 9.5C7 8.67157 7.67157 8 8.5 8C9.32843 8 10 8.67157 10 9.5ZM17 14.5C17 15.3284 16.3284 16 15.5 16C14.6716 16 14 15.3284 14 14.5C14 13.6716 14.6716 13 15.5 13C16.3284 13 17 13.6716 17 14.5Z"
				fill="currentColor"
			/>
			<path
				d="M15 7L9 17M10 9.5C10 10.3284 9.32843 11 8.5 11C7.67157 11 7 10.3284 7 9.5C7 8.67157 7.67157 8 8.5 8C9.32843 8 10 8.67157 10 9.5ZM17 14.5C17 15.3284 16.3284 16 15.5 16C14.6716 16 14 15.3284 14 14.5C14 13.6716 14.6716 13 15.5 13C16.3284 13 17 13.6716 17 14.5ZM22 12V12C22 6.47715 17.5228 2 12 2V2C6.47715 2 2 6.47715 2 12V12C2 17.5228 6.47715 22 12 22V22C17.5228 22 22 17.5228 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM15.643 7.38587C15.8561 7.03069 15.7409 6.56999 15.3857 6.35688C15.0306 6.14377 14.5699 6.25894 14.3568 6.61413L8.35676 16.6141C8.14365 16.9693 8.25882 17.43 8.61401 17.6431C8.96919 17.8562 9.42989 17.7411 9.643 17.3859L15.643 7.38587ZM7.74988 9.5C7.74988 9.08579 8.08566 8.75 8.49988 8.75C8.91409 8.75 9.24988 9.08579 9.24988 9.5C9.24988 9.91421 8.91409 10.25 8.49988 10.25C8.08566 10.25 7.74988 9.91421 7.74988 9.5ZM8.49988 7.25C7.25724 7.25 6.24988 8.25736 6.24988 9.5C6.24988 10.7426 7.25724 11.75 8.49988 11.75C9.74252 11.75 10.7499 10.7426 10.7499 9.5C10.7499 8.25736 9.74252 7.25 8.49988 7.25ZM14.7499 14.5C14.7499 14.0858 15.0857 13.75 15.4999 13.75C15.9141 13.75 16.2499 14.0858 16.2499 14.5C16.2499 14.9142 15.9141 15.25 15.4999 15.25C15.0857 15.25 14.7499 14.9142 14.7499 14.5ZM15.4999 12.25C14.2572 12.25 13.2499 13.2574 13.2499 14.5C13.2499 15.7426 14.2572 16.75 15.4999 16.75C16.7425 16.75 17.7499 15.7426 17.7499 14.5C17.7499 13.2574 16.7425 12.25 15.4999 12.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M16 2.83209C14.7751 2.2969 13.4222 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 9.74835 21.2558 7.67051 20 5.99902M14.9999 7L8.99988 17M9.99988 9.5C9.99988 10.3284 9.32831 11 8.49988 11C7.67145 11 6.99988 10.3284 6.99988 9.5C6.99988 8.67157 7.67145 8 8.49988 8C9.32831 8 9.99988 8.67157 9.99988 9.5ZM16.9999 14.5C16.9999 15.3284 16.3283 16 15.4999 16C14.6715 16 13.9999 15.3284 13.9999 14.5C13.9999 13.6716 14.6715 13 15.4999 13C16.3283 13 16.9999 13.6716 16.9999 14.5Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M14.9999 7L8.99988 17M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM9.99988 9.5C9.99988 10.3284 9.32831 11 8.49988 11C7.67145 11 6.99988 10.3284 6.99988 9.5C6.99988 8.67157 7.67145 8 8.49988 8C9.32831 8 9.99988 8.67157 9.99988 9.5ZM16.9999 14.5C16.9999 15.3284 16.3283 16 15.4999 16C14.6715 16 13.9999 15.3284 13.9999 14.5C13.9999 13.6716 14.6715 13 15.4999 13C16.3283 13 16.9999 13.6716 16.9999 14.5Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.3859 6.35699C15.7411 6.5701 15.8562 7.0308 15.6431 7.38599L9.64312 17.386C9.43001 17.7412 8.96931 17.8563 8.61413 17.6432C8.25894 17.4301 8.14377 16.9694 8.35688 16.6142L14.3569 6.61424C14.57 6.25906 15.0307 6.14388 15.3859 6.35699ZM8.5 8.75011C8.08579 8.75011 7.75 9.0859 7.75 9.50011C7.75 9.91433 8.08579 10.2501 8.5 10.2501C8.91421 10.2501 9.25 9.91433 9.25 9.50011C9.25 9.0859 8.91421 8.75011 8.5 8.75011ZM6.25 9.50011C6.25 8.25747 7.25736 7.25011 8.5 7.25011C9.74264 7.25011 10.75 8.25747 10.75 9.50011C10.75 10.7428 9.74264 11.7501 8.5 11.7501C7.25736 11.7501 6.25 10.7428 6.25 9.50011ZM15.5 13.7501C15.0858 13.7501 14.75 14.0859 14.75 14.5001C14.75 14.9143 15.0858 15.2501 15.5 15.2501C15.9142 15.2501 16.25 14.9143 16.25 14.5001C16.25 14.0859 15.9142 13.7501 15.5 13.7501ZM13.25 14.5001C13.25 13.2575 14.2574 12.2501 15.5 12.2501C16.7426 12.2501 17.75 13.2575 17.75 14.5001C17.75 15.7428 16.7426 16.7501 15.5 16.7501C14.2574 16.7501 13.25 15.7428 13.25 14.5001Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
